module.exports = __webpack_public_path__ + "img/rectangle.4f41e446.svg";